import { Utils } from "@/src/pages/optimus/service";
import React from "react"

type EditSelfReminderFormLimitRepProps = {
    isCheckedOnce: boolean,
    onClickOnce:  (e: React.ChangeEvent<HTMLInputElement>) => void,
    isCheckedMulti: boolean,
    onClickMonth:  (e: React.ChangeEvent<HTMLInputElement>) => void,
    monthOffset: number,
    onClickDecrementMonthOffset: (e: React.MouseEvent<HTMLButtonElement>) => void,
    onClickIncrementMonthOffset: (e: React.MouseEvent<HTMLButtonElement>) => void,
}

const EditSelfReminderFormLimitRep: React.FC<EditSelfReminderFormLimitRepProps> = ({
    isCheckedOnce, onClickOnce,
    isCheckedMulti, onClickMonth,
    monthOffset, onClickDecrementMonthOffset, onClickIncrementMonthOffset
}: EditSelfReminderFormLimitRepProps) => {
    const endMonth = Utils.getTodayEndMonth(monthOffset);
    const endMonthString = endMonth.toLocaleString("th-TH", { month: "short", year: '2-digit' });

    return (
        <>
            <label className="flex flex-row p-3 border-x-2 border-b-2 radio-label items-center h-14 select-none rounded-b-xl">
                <input
                    type="radio" id="dateEnd-month"
                    name="dateEnd" className="peer mr-2"
                    onChange={onClickMonth} checked={isCheckedMulti}
                />
                <span className="box-border inline-flex items-center w-full">เตือนไปอีก
                    <div className="flex-1" />
                    <div className="inline-flex flex-row gap-2 pl-4 items-center">
                        <button
                            className="flex items-center text-primary-blue border-2 text-xl px-2 box-border rounded-lg shadow-sm active:bg-bright-blue active:text-white"
                            disabled={monthOffset <= 1}
                            onClick={onClickDecrementMonthOffset}
                        >-</button>
                        <span className="w-30 flex justify-center items-stretch gap-1 pr-1">
                            <span className="block flex-1 text-right">{monthOffset}</span>
                            <span className="block">เดือน <span className="text-sm font-light">({endMonthString})</span></span>
                        </span>
                        <button
                            className="flex items-center text-primary-blue border-2 text-xl px-2 box-border rounded-lg shadow-sm active:bg-bright-blue active:text-white"
                            disabled={monthOffset >= 24}
                            onClick={onClickIncrementMonthOffset}
                        >+</button>
                    </div>
                </span>
            </label>
        </>
    );
}

export default EditSelfReminderFormLimitRep;
export type { EditSelfReminderFormLimitRepProps };